import { useTranslation } from 'next-i18next';
import React, { ReactElement } from 'react';

import { settlementsInstancesTableColumns } from '@/modules/Settlements/components/Details/CrewLevel/MainPayablesDays/logic';
import { ISettlements } from '@/modules/Settlements/types';
import { Table } from '@/shared/components/atoms';
import { useStore } from '@/shared/hooks/context/createGenericContext';

interface IInstancesTableProps {
  data: ISettlements.ISettlementDetailsDayInstance[];
}

export default function InstancesTable({
  data,
}: IInstancesTableProps): ReactElement {
  const { t } = useTranslation('common');
  const [selectedAsset] = useStore((store) => store?.asset);

  // if no data found
  if (!data) {
    return (
      <div className=' w-full rounded-lg bg-white px-0 py-16 text-center text-20 font-semi-bold'>
        {t('no-instance')}
      </div>
    );
  }

  return (
    <div className=''>
      <Table<ISettlements.ISettlementDetailsDayInstance>
        columnsDividerIndexes={[4, 6, 11, 21]}
        // stickyFirstCloumn
        // stickyNCloumns={4}
        tableWrapperClassName='max-h-520 text-center'
        // rowContainerClassName='cursor-pointer'
        selection={false}
        columns={settlementsInstancesTableColumns(
          t,
          selectedAsset?.currency || ''
        )}
        // filter data in case wasred time and total hours 0
        data={data}
        pagination={false}
      />
    </div>
  );
}
